export default __webpack_public_path__ + "static/media/DanskeNarrow.56272900.woff";